const PreStartCheckListList = () =>
  import(/* webpackChunkName: "main_app" */ "./pages/ListPage.vue");
const PreStartCheckListDetail = () =>
  import(/* webpackChunkName: "main_app" */ "./pages/FormPage.vue");
const PreStartCheckListIndex = () =>
  import(/* webpackChunkName: "main_app" */ "./pages/IndexPage.vue");

export default [
  {
    path: "/pre_start_check_list",
    component: PreStartCheckListIndex,
    redirect: "/pre_start_check_list/list",
    name: "pre_start_check_list",
    children: [
      {
        path: "list",
        component: PreStartCheckListList,
        name: "pre_start_check_list.list",
      },
      {
        path: "create",
        component: PreStartCheckListDetail,
        name: "pre_start_check_list.create",
        props: {create: true},
      },
      {
        path: "edit/:id",
        component: PreStartCheckListDetail,
        name: "pre_start_check_list.edit",
        props: {create: false},
      },
    ],
  },
];
